/**
 * Анон-MVP (#323/#12) — публичные эндпойнты витрины отеля БЕЗ JWT.
 *
 * Все вызовы проходят через `customFetch` с `noAuth: true` — Authorization
 * НЕ отправляется, даже если в хранилище остался токен (анон-режим на
 * `<slug>.lovarthotels.com` должен работать одинаково для гостя и зашедшего).
 * Тенант резолвится backend'ом по `{slug}` в пути (PublicResolver), как в
 * room/events MountPublic. Эндпойнты под `publicRateLimiter` (60 req/min/IP).
 *
 * Контракт — anon-brief (раздел КОНТРАКТ НОВЫХ ЭНДПОЙНТОВ):
 *   GET  /v1/public/{slug}/room-types   — каталог номеров (internal/room)
 *   GET  /v1/public/{slug}/hotel-info   — об отеле (A)
 *   POST /v1/public/{slug}/booking-lead — заявка-лид (B)
 */
import { customFetch } from './openapi-fetch.js';
import type {
  BookingLeadCreatedResponse,
  BookingLeadInput,
  PublicHotelInfo,
  PublicRoomsResponse,
  PublicRoomTypesResponse,
} from '@hsc/types';

function publicBase(slug: string): string {
  return `/public/${encodeURIComponent(slug)}`;
}

/** GET /v1/public/{slug}/room-types — публичный каталог типов номеров. */
export async function getPublicRoomTypes(slug: string): Promise<PublicRoomTypesResponse> {
  return customFetch<PublicRoomTypesResponse>({
    url: `${publicBase(slug)}/room-types`,
    method: 'GET',
    noAuth: true,
  });
}

/** GET /v1/public/{slug}/rooms — номера комнат отеля для гостевой выпадайки. */
export async function getPublicRooms(slug: string): Promise<PublicRoomsResponse> {
  return customFetch<PublicRoomsResponse>({
    url: `${publicBase(slug)}/rooms`,
    method: 'GET',
    noAuth: true,
  });
}

/** GET /v1/public/{slug}/hotel-info — публичная карточка «об отеле» (контракт A). */
export async function getPublicHotelInfo(slug: string): Promise<PublicHotelInfo> {
  return customFetch<PublicHotelInfo>({
    url: `${publicBase(slug)}/hotel-info`,
    method: 'GET',
    noAuth: true,
  });
}

/** POST /v1/public/{slug}/booking-lead — заявка-лид без онлайн-оплаты (контракт B). */
export async function createBookingLead(
  slug: string,
  body: BookingLeadInput,
): Promise<BookingLeadCreatedResponse> {
  return customFetch<BookingLeadCreatedResponse>({
    url: `${publicBase(slug)}/booking-lead`,
    method: 'POST',
    data: body,
    noAuth: true,
  });
}
